import { useRef, useEffect } from 'react';
import { pm2SitemapStore, findCourseDescriptorFromParents } from '@pm2/sitemap-utils';
import { breakpoints } from '@ui/css';
import { throttleToAnimationFrame } from '@utils/common';
import { jsx } from 'react/jsx-runtime';
import { Footer } from '../footer/footer.casing.js';

const SVG_GRAPHIC_MOBILE_OFFSET_PX = 50;
const SVG_GRAPHIC_DESKTOP_OFFSET_PX = 160;
let LAST_MOUNTED_FOOTER;

/**
 * bottom navigation for the current page, if any is available based on the
 * navigation tree and page type.
 */
const BottomNavigation = ({
  pageDescriptor
}) => {
  const ref = useRef(null);
  const sitemap = pm2SitemapStore.useSelector(state => state);
  useEffect(() => {
    const footer = ref.current;
    if (footer) {
      LAST_MOUNTED_FOOTER = footer;
      const isMobile = matchMedia(breakpoints.mobile.andDown().toQuery()).matches;
      const updateHeight = () => {
        document.documentElement.style.setProperty("--footer--height", `${footer.offsetHeight + (isMobile ? SVG_GRAPHIC_MOBILE_OFFSET_PX : SVG_GRAPHIC_DESKTOP_OFFSET_PX)}px`);
      };

      // update footer height on mount
      updateHeight();

      // ... and on resizing of the browser
      const handleResize = throttleToAnimationFrame(updateHeight);
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);

        // remove footer height on unmount
        if (footer === LAST_MOUNTED_FOOTER) {
          document.documentElement.style.removeProperty("--footer--height");
          LAST_MOUNTED_FOOTER = undefined;
        }
      };
    } else {
      LAST_MOUNTED_FOOTER = undefined;

      // remove footer height if no footer was mounted
      document.documentElement.style.removeProperty("--footer--height");
    }
  }, [pageDescriptor.id]);

  // on the home page we render the site footer as a bottom navigation
  if (pageDescriptor.path === "/") {
    return /*#__PURE__*/jsx(Footer, {
      pageDescriptor: pageDescriptor,
      footerRef: ref,
      showColumn: true
    });
  }

  // ... otherwise check if we're currently inside a course, and in that case
  // render navigation from that point on
  const courseDescriptor = findCourseDescriptorFromParents(sitemap, pageDescriptor);
  if (courseDescriptor !== undefined && pageDescriptor !== courseDescriptor) {
    return /*#__PURE__*/jsx(Footer, {
      footerRef: ref,
      courseDescriptor: courseDescriptor,
      pageDescriptor: pageDescriptor,
      showNavigation: true
    });
  }
  return /*#__PURE__*/jsx(Footer, {
    pageDescriptor: pageDescriptor,
    footerRef: ref
  });
};

export { BottomNavigation };
//# sourceMappingURL=bottom-navigation.js.map
